import { SHRINK_TYPE, TEMPLATE_TYPE } from 'screens/YieldV2/constants';
import { percentToDecimal } from 'utilities/numberHelpers';

const processYieldTickets = yieldTickets => {
  const processed = yieldTickets.map(ticket => {
    const {
      sources,
      destination,
      load,
      tareWeight,
      grossWeight,
      grossRevenue,
      netWeight,
      salePrice,
      sourceType,
      templateType,
      harvestedQuantity,
      ...values
    } = ticket;

    const loadAttributes = {};

    if (templateType === TEMPLATE_TYPE.ROW_CROP) {
      loadAttributes.damage = percentToDecimal(values.damage);
      loadAttributes.foreignMaterial = percentToDecimal(values.foreignMaterial);
      loadAttributes.moisture = percentToDecimal(values.moisture);

      if (values.shrinkType === SHRINK_TYPE.BY_PERCENT) {
        loadAttributes.shrink = percentToDecimal(values.shrink);
      } else if (values.shrinkType === SHRINK_TYPE.BY_QUANTITY) {
        loadAttributes.shrink = values.shrink
          ? Number.parseFloat(values.shrink)
          : 0;
      }
    }

    if (templateType === TEMPLATE_TYPE.SPECIALTY) {
      loadAttributes.damage = percentToDecimal(values.damage);
      loadAttributes.foreignMaterial = percentToDecimal(values.foreignMaterial);
    }

    return {
      ...values,
      templateType,
      loadTemporaryId: undefined,
      sources: sources.map(source => ({
        id: source.id
      })),
      sourceType,
      destinationId: destination.id,
      destinationType: destination.type,
      load: Number.parseFloat(load),
      harvestedQuantity: harvestedQuantity
        ? Number.parseFloat(harvestedQuantity)
        : null,
      tareWeight: tareWeight ? Number.parseFloat(tareWeight) : null,
      grossWeight: grossWeight ? Number.parseFloat(grossWeight) : null,
      grossRevenue: grossRevenue ? Number.parseFloat(grossRevenue) : null,
      netWeight: netWeight ? Number.parseFloat(netWeight) : null,
      salePrice: salePrice ? Number.parseFloat(salePrice) : null,
      cropZones: null,
      avgYieldPerAcre: 0, // old v1 property, need to be removed on backend
      ...loadAttributes
    };
  });
  return processed;
};

export default processYieldTickets;
